import { createSelector } from 'reselect'

export const LOGIN_USER = 'LOGIN_USER'
export const SET_USER_DATA = 'SET_USER_DATA'
export const LOGOUT_USER = 'LOGOUT_USER'

const initialState = {
  isAuth: false,
}

const userDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_DATA:
      return {
        ...state,
        ...action.userData,
      }
    case LOGIN_USER:
      return {
        ...state,
        isAuth: true,
      }
    case LOGOUT_USER:
      return {
        ...state,
        isAuth: false,
      }
    default:
      return state
  }
}

export const loginUser = () => {
  return {
    type: LOGIN_USER,
  }
}

export const logoutUser = () => {
  return {
    type: LOGOUT_USER,
  }
}

export const setUserData = (userData) => {
  return {
    type: SET_USER_DATA,
    userData,
  }
}

// --------SELECTORS--------

export const selectIsAuth = (state) => state.userData.isAuth

export const selectUserData = (state) => state.userData

export const selectUserDataUniqId = (state) => (state.userData.user ? state.userData.user.id : null)

export const selectUserUniqBuilding = (state) =>
  state.userData.buildingId ? state.userData.buildingId : null

export const selectUserRole = (state) => (state.userData.user ? state.userData.user.role : null)

export const selectUserBuilding = createSelector(selectUserData, (user) => user.buildingId)

export const selectUserBuildingName = createSelector(selectUserBuilding, (building) =>
  building ? building.name : '',
)

export default userDataReducer
